import { ProfileComponentType } from "@authory-packages/core";
import {
    V3IconBlueSky,
    V3IconCalendar,
    V3IconFacebook,
    V3IconInstagram,
    V3IconLinkedin,
    V3IconMessage,
    V3IconThreads,
    V3IconTwitter,
    V3IconWeb,
    V3IconYoutube
} from "../Icons";

export const getSocialSVG = (network: ProfileComponentType) => {
    switch (network) {
        case ProfileComponentType.ThreadsLink:
            return <V3IconThreads />;
        case ProfileComponentType.TwitterLink:
            return <V3IconTwitter />;
        case ProfileComponentType.FacebookLink:
            return <V3IconFacebook />;
        case ProfileComponentType.LinkedinLink:
            return <V3IconLinkedin />;
        case ProfileComponentType.InstagramLink:
            return <V3IconInstagram />;
        case ProfileComponentType.PersonalLink:
            return <V3IconWeb />;
        case ProfileComponentType.BlueskyLink:
            return <V3IconBlueSky fill="#1185FE" />;
        case ProfileComponentType.PinterestLink:
            return <img src="/authory_static_files/images/social-icons/pinterest.svg" />;
        case ProfileComponentType.SoundcloudLink:
            return <img src="/authory_static_files/images/social-icons/soundcloud.svg" />;
        case ProfileComponentType.PatreonLink:
            return <img src="/authory_static_files/images/social-icons/patreon.svg" />;
        case ProfileComponentType.RedditLink:
            return <img src="/authory_static_files/images/social-icons/reddit.svg" />;
        case ProfileComponentType.QuoraLink:
            return <img src="/authory_static_files/images/social-icons/quorra.svg" />;
        case ProfileComponentType.MastodonLink:
            return <img src="/authory_static_files/images/social-icons/mastodon.svg" />;
        case ProfileComponentType.TumblrLink:
            return <img src="/authory_static_files/images/social-icons/tumblr.svg" />;
        case ProfileComponentType.VimeoLink:
            return <img src="/authory_static_files/images/social-icons/vimeo.svg" />;
        case ProfileComponentType.TikTokLink:
            return <img src="/authory_static_files/images/social-icons/tiktok.svg" />;
        case ProfileComponentType.YoutubeLink:
            return <V3IconYoutube />;
        case ProfileComponentType.Calendar:
            return <V3IconCalendar />;
        case ProfileComponentType.Mail:
            return <V3IconMessage />;
        case ProfileComponentType.Phone:
            return <img src="/authory_static_files/images/social-icons/phone.svg" />;
        case ProfileComponentType.Location:
            return <img src="/authory_static_files/images/social-icons/location.svg" />;
        case ProfileComponentType.Home:
            return <img src="/authory_static_files/images/social-icons/home.svg" />;
        case ProfileComponentType.Video:
            return <img src="/authory_static_files/images/social-icons/video.svg" />;
        case ProfileComponentType.Info:
            return <img src="/authory_static_files/images/social-icons/info.svg" />;
        default:
            return <V3IconWeb />;
    }
};

export const getSocialLabel = (network: ProfileComponentType) => {
    switch (network) {
        case ProfileComponentType.ThreadsLink:
            return "Threads";
        case ProfileComponentType.TwitterLink:
            return "X (Twitter)";
        case ProfileComponentType.BlueskyLink:
            return "Bluesky";
        case ProfileComponentType.FacebookLink:
            return "Facebook";
        case ProfileComponentType.LinkedinLink:
            return "LinkedIn";
        case ProfileComponentType.InstagramLink:
            return "Instagram";
        case ProfileComponentType.PinterestLink:
            return "Pinterest";
        case ProfileComponentType.SoundcloudLink:
            return "Soundcloud";
        case ProfileComponentType.PatreonLink:
            return "Patreon";
        case ProfileComponentType.RedditLink:
            return "Reddit";
        case ProfileComponentType.QuoraLink:
            return "Quora";
        case ProfileComponentType.MastodonLink:
            return "Mastodon";
        case ProfileComponentType.TumblrLink:
            return "Tumblr";
        case ProfileComponentType.VimeoLink:
            return "Vimeo";
        case ProfileComponentType.TikTokLink:
            return "Tiktok";
        case ProfileComponentType.YoutubeLink:
            return "YouTube";
        case ProfileComponentType.Calendar:
            return "Calendar";
        case ProfileComponentType.Mail:
            return "Mail";
        case ProfileComponentType.Phone:
            return "Phone";
        case ProfileComponentType.Location:
            return "Location";
        case ProfileComponentType.Home:
            return "Home";
        case ProfileComponentType.Video:
            return "Video";
        case ProfileComponentType.Info:
            return "Info";
        case ProfileComponentType.PersonalLink:
        default:
            return "Web";
    }
};

export const getPlaceholderLabel = (network: ProfileComponentType) => {
    switch (network) {
        case ProfileComponentType.TwitterLink:
            return "e.g. twitter.com/johndoe";
        case ProfileComponentType.FacebookLink:
            return "e.g. facebook.com/johndoe";
        case ProfileComponentType.LinkedinLink:
            return "e.g. linkedin.com/in/john-doe";
        case ProfileComponentType.InstagramLink:
            return "e.g. instagram.com/john-doe";
        case ProfileComponentType.PinterestLink:
            return "e.g. pinterest.com/jonh-doe";
        case ProfileComponentType.BlueskyLink:
            return "e.g. bsky.app/profile/johndoe.bsky.social";
        case ProfileComponentType.SoundcloudLink:
            return "e.g. soundcloud.com/jonh-doe";
        case ProfileComponentType.TikTokLink:
            return "e.g. tiktok.com/jonh-doe";
        case ProfileComponentType.YoutubeLink:
            return "e.g. youtube.com/user/jonh-doe";
        case ProfileComponentType.PatreonLink:
            return "e.g. patreon.com/jonh-doe";
        case ProfileComponentType.RedditLink:
            return "e.g. reddit.com/r/jonh-doe";
        case ProfileComponentType.QuoraLink:
            return "e.g. quora.com/topic/jonh-doe";
        case ProfileComponentType.TumblrLink:
            return "e.g. tumblr.com/jonh-doe";
        case ProfileComponentType.MastodonLink:
            return "e.g. mstdn.social/jonh-doe";
        case ProfileComponentType.VimeoLink:
            return "e.g.vimeo.com/jonh-doe";
        case ProfileComponentType.Calendar:
            return "e.g. calendly.com/jonh-doe";
        case ProfileComponentType.Phone:
            return "e.g. +351999999999";
        case ProfileComponentType.Mail:
            return "e.g. jonhedoe@gmail.com";
        case ProfileComponentType.Location:
            return "e.g. goo.gl/maps/jonh-doe";
        case ProfileComponentType.PersonalLink:
        default:
            return "e.g. johndoe.com";
    }
};
